import React, { useState } from 'react';
import { useOptimizedPublisherAnalysis } from './context/OptimizedPublisherAnalysisContext';
import { useUserPlans } from '../../hooks/useReactQueryHooks';
import AppsTrackingPlanModal from '../Common/Modal/AppsTrackingPlanModal';
import ExportUpgradeModal from '../Common/Modal/ExportUpgradeModal';
import PlatformTabs from '../Common/PlatformTabs';
import { useAnalytics, ANALYTICS_EVENTS } from '../../analytics';
import './style/tabsSection.scss';

const TabsSection = () => {
  const { activeTab, setActiveTab, handlePlatformChange, categoryApps, loader, setShowExportModal } = useOptimizedPublisherAnalysis();
  const { trackEvent } = useAnalytics();
  const { data: plansData } = useUserPlans();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showExportInfoModal, setShowExportInfoModal] = useState(false);

  const determineCanExport = (plans) => {
    // Flexible checks to handle different API shapes.
    if (!plans) return false;

    const payload = plans.data ?? plans;

    // If array of plans
    if (Array.isArray(payload)) {
      if (payload.length === 0) return false;
      // Try to find an active/non-default plan
      const activePlan = payload.find(p => p.is_active || p.is_current || p.active) || payload[0];
      const name = (activePlan && (activePlan.name || activePlan.title || activePlan.product?.name)) || '';
      const lname = String(name).toLowerCase();
      if (!name) return false;
      if (lname.includes('explorer') || lname.includes('free') || lname.includes('no plan') || lname.includes('trial')) return false;
      return true;
    }

    // If object, try a few locations
    const objName = payload.product?.name || payload.name || payload.plan || payload.current_plan?.name || '';
    if (!objName) return false;
    const on = String(objName).toLowerCase();
    if (on.includes('explorer') || on.includes('free') || on.includes('no plan') || on.includes('trial')) return false;
    return true;
  }

  const canExport = determineCanExport(plansData) && !loader;

  
  if (loader || !categoryApps || categoryApps.length === 0) {
    return (
      <div className="publisher-tabs">
        <div className="publisher-tabs-row">
          <div className="tabs-left">
            <PlatformTabs activeTab={activeTab} disabled variant="pill" showDivider={false} />
          </div>
          <div className="tabs-right">
            <div className="csv_btn">
              {canExport ? (
                <a href="#" onClick={(e) => { e.preventDefault(); setShowExportModal(true); }}>Export</a>
              ) : (
                <a
                  href="#"
                  className="disabled"
                  onClick={(e) => { e.preventDefault(); setShowExportInfoModal(true); }}
                  title="Upgrade your plan to enable exports"
                >
                  Export
                </a>
              )}
            </div>
            <ExportUpgradeModal
              show={showExportInfoModal}
              handleClose={() => setShowExportInfoModal(false)}
              onUpgradeClick={() => {
                setShowExportInfoModal(false);
                setShowUpgradeModal(true);
              }}
            />
            <AppsTrackingPlanModal show={showUpgradeModal} handleClose={() => setShowUpgradeModal(false)} />
          </div>
        </div>
        <div className="publisher-tabs-divider" />
      </div>
    );
  }

  return (
    <div className="publisher-tabs">
      <div className="publisher-tabs-row">
        <div className="tabs-left">
          <PlatformTabs
            activeTab={activeTab}
            onChange={(id) => {
              setActiveTab(id);
              handlePlatformChange(id);
              trackEvent(ANALYTICS_EVENTS.FEATURE.PUBLISHER_DASHBOARD_TAB_CHANGED, { tab: id });
            }}
            variant="pill"
            showDivider={false}
          />
        </div>

        <div className="tabs-right">
          <div className="csv_btn">
            {canExport ? (
              <a href="#" onClick={(e) => { e.preventDefault(); setShowExportModal(true); }}>Export</a>
            ) : (
              <a
                href="#"
                className="disabled"
                onClick={(e) => { e.preventDefault(); setShowExportInfoModal(true); }}
                title="Upgrade your plan to enable exports"
              >
                Export
              </a>
            )}
          </div>
          <ExportUpgradeModal
            show={showExportInfoModal}
            handleClose={() => setShowExportInfoModal(false)}
            onUpgradeClick={() => {
              setShowExportInfoModal(false);
              setShowUpgradeModal(true);
            }}
          />
          <AppsTrackingPlanModal show={showUpgradeModal} handleClose={() => setShowUpgradeModal(false)} />
        </div>
      </div>
      <div className="publisher-tabs-divider" />
    </div>
  );
};

export default TabsSection;
